<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
                <el-form-item>
                    <el-input v-model.trim="search.user_uid" @change="Search('search')" placeholder="用户uid"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="search.device_uuid" @change="Search('search')"
                        placeholder="设备uuid"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.reason" @change="Search('search')" clearable placeholder="原因">
                        <el-option label="价格太贵" value="too_expensive"></el-option>
                        <el-option label="缺少想要的功能" value="lacks_features"></el-option>
                        <el-option label="暂时不需要" value="temporary_not_need"></el-option>
                        <el-option label="产品体验问题（如卡顿等）" value="experience_issues"></el-option>
                        <el-option label="找到可替代的产品" value="found_alternative"></el-option>
                        <el-option label="流媒体加载速度慢" value="live_streaming_to_slow"></el-option>
                        <el-option label="APP服务不满意" value="unsatisfied_with_app_service"></el-option>
                        <el-option label="其他" value="other"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.sub_option" @change="Search('search')" clearable placeholder="二级选项">
                        <el-option label="每月6-9美元" value="six_nine_range"></el-option>
                        <el-option label="每月3-6美元" value="three_six_range"></el-option>
                        <el-option label="每月低于3美元以下" value="low_three_range"></el-option>
                        <el-option label="APP有Bug" value="app_has_bug"></el-option>
                        <el-option label="提醒频率问题(通知太多或太少)" value="inaccurate_event_alerts"></el-option>
                        <el-option label="事件未完全记录" value="event_recording_too_short"></el-option>
                        <el-option label="事件标签不准确" value="event_detect_inaccurate"></el-option>
                        <el-option label="事件的Ai文字描述不准确" value="event_ai_describe_inaccurate"></el-option>
                        <el-option label="其他" value="other"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="date1" :clearable="false" @blur="focusEvent1" type="datetime"
                        placeholder="开始时间" :shortcuts="shortcuts" @change="selectTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="date2" :clearable="false" @blur="focusEvent2" type="datetime"
                        placeholder="结束时间" :shortcuts="shortcuts" @change="selectTime1">
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>
        <!-- 列表 -->
        <el-table border v-bind:data="list">
            <el-table-column label="联系邮箱">
                <template v-slot="scope">
                    <span>{{ scope.row.email }}</span>
                </template>
            </el-table-column>
            <el-table-column label="原因">
                <template v-slot="scope">
                    <span>{{ ReasonMap[scope.row.reason] || scope.row.reason }}</span>
                </template>
            </el-table-column>
            <el-table-column label="意见" width="240" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.comments }}</span>
                </template>
            </el-table-column>
            <el-table-column label="二级选项">
                <template v-slot="scope">
                    <span>{{ SubOptionMap[scope.row.sub_option] || scope.row.sub_option }}</span>
                </template>
            </el-table-column>
            <el-table-column label="二级意见" width="240" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.sub_comment }}</span>
                </template>
            </el-table-column>
            <el-table-column label="用户uid" width="160">
                <template v-slot="scope">
                    <span>{{ scope.row.user_uid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="设备uuid" width="160">
                <template v-slot="scope">
                    <span>{{ scope.row.device_uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
            <el-table-column label="修改时间" width="120">
                <template v-slot="scope">
                    <span>{{ scope.row.updated_at }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-button type="text" :disabled="predisabled" @click="prePage" size="mini">上一页</el-button>
            <el-button type="text" :disabled="nextdisabled" @click="nextPage" size="mini">下一页</el-button>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import util from '../../../util/util'

const ReasonMap = {
    too_expensive: '价格太贵',
    lacks_features: '缺少想要的功能',
    temporary_not_need: '暂时不需要',
    experience_issues: '产品体验问题（如卡顿等）',
    found_alternative: '找到可替代的产品',
    live_streaming_to_slow: '流媒体加载速度慢',
    unsatisfied_with_app_service: 'APP服务不满意',
    other: '其他'
}

const SubOptionMap = {
    six_nine_range: '每月6-9美元',
    three_six_range: '每月3-6美元',
    low_three_range: '每月低于3美元以下',
    app_has_bug: 'APP有Bug',
    inaccurate_event_alerts: '提醒频率问题(通知太多或太少)',
    event_recording_too_short: '事件未完全记录',
    event_detect_inaccurate: '事件标签不准确',
    event_ai_describe_inaccurate: '事件的Ai文字描述不准确',
    other: '其他'
}

export default {
    name: '',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            ReasonMap,
            SubOptionMap,
            shortcuts: [
                {
                    text: '今天',
                    value: new Date(),
                },
                {
                    text: '昨天',
                    value: () => {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24)
                        return date
                    },
                },
            ],
            search: {
                last_id: '',
                action: 1,
                user_uid: '',
                device_uuid: '',
                start_time: '',
                end_time: '',
                rows: 10,
            },
            list: [],
            feedtypelist: [],
            modellist: [],
            modelIdName: {},
            feedtypeIdName: {},
            predisabled: false,
            nextdisabled: false,
            date1: '',
            date2: '',
            brandlist: []
        }
    },
    computed: {},
    watch: {},
    methods: {
        focusEvent1() {
            if (!this.date1) {
                this.search.start_time = ''
                this.Search()
            }
        },
        focusEvent2() {
            if (!this.date2) {
                this.search.end_time = ''
                this.Search()
            }
        },
        selectTime() {
            if (this.date1) {
                if (this.search.start_time == this.date1.getTime() / 1000) {
                    return
                }
                this.search.start_time = this.date1.getTime() / 1000
                this.Search(('search'))
            } else {
                this.search.start_time = ''
                this.Search(('search'))
            }
        },
        selectTime1() {
            if (this.date2) {
                if (this.search.end_time == this.date2.getTime() / 1000) {
                    return
                }
                this.search.end_time = this.date2.getTime() / 1000
                this.Search(('search'))
            } else {
                this.search.end_time = ''
                this.Search(('search'))
            }
        },
        prePage() {
            this.search.action = 2
            this.search.last_id = this.list[0].id
            this.Search('page')
        },
        nextPage() {
            this.search.action = 1
            this.search.last_id = this.list[this.list.length - 1].id
            this.Search('page')
        },
        Search(item) {
            console.log('事件源', item)
            if (item == 'search') {
                this.search.last_id = ''
            }
            if (this.search.start_time !== '' && this.search.start_time == this.search.end_time) {
                this.$message.error('开始时间不能等于结束时间!')
                this.list = []
                return
            }
            this.api.CancelsubFeedBackList(this.search).then(res => {
                if (res.data.code == 200) {
                    if (!res.data.data && item == 'search') {
                        this.list = []
                    }
                    if (res.data.data.data) {
                        if (this.search.action == 2) {
                            this.nextdisabled = false
                        } else {
                            this.predisabled = false
                        }
                        this.list = res.data.data.data
                    } else {
                        if (item == 'search') {
                            this.list = []
                        } else if (item == 'page') {
                            if (this.search.action == 2) {
                                this.predisabled = true
                            } else {
                                this.nextdisabled = true
                            }
                        }
                    }
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        changeTime(item) {
            return util.dateFormat(item)
        }
    },
    filters: {},
    mounted() {
        this.Search()
    },
    created() {
    }
}
</script>
<style>
.el-picker-panel__footer {
    display: none
}
</style>
<style scoped lang="stylus" rel="stylesheet/stylus">
.page {
  float: right;
  margin-top: 10px
}
</style>
